import { render, staticRenderFns } from "./jkjd.vue?vue&type=template&id=d10d39c8&scoped=true&"
import script from "./jkjd.vue?vue&type=script&lang=js&"
export * from "./jkjd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10d39c8",
  null
  
)

export default component.exports